import { type ElementStyles, css } from '@microsoft/fast-element';
import type { HoverIconDefinition, HoverIcon } from './HoverIcon';
import { SettingsFilled, SettingsRegular } from '@fluentui/react-icons/fonts';
import { lazySaveShowSettingsHoverAction } from 'owa-surface-actions-option';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { settingsTitle } from 'owa-mail-list-item-shared/lib/utils/getHoverActionIcon.locstring.json';

const SettingsRegularFontGlyph = SettingsRegular.codepoint;
const SettingsFilledFontGlyph = SettingsFilled.codepoint;

const BaseSettingsIconStyles: ElementStyles = css`
    .icon:before {
        color: var(--colorNeutralForeground3);
        content: '${SettingsRegularFontGlyph}';
    }

    :host(:hover) .icon:before,
    :host(:active) .icon:before {
        color: var(--customBlueForeground1);
        content: '${SettingsFilledFontGlyph}';
    }
`;

export const Settings: HoverIconDefinition = {
    title(this: Readonly<HoverIcon>) {
        return settingsTitle;
    },
    customCss: BaseSettingsIconStyles,
    onClick(this: HoverIcon) {
        lazySaveShowSettingsHoverAction.importAndExecute().then(() => {
            lazyMountAndShowFullOptions.importAndExecute('mail', 'surfaceActions');
        });
    },
};
